/* eslint import/prefer-default-export: off */
export const RESULT_TYPE_MATH = "RESULT_TYPE_MATH"
export const RESULT_TYPE_COLOR = "RESULT_TYPE_COLOR"
export const RESULT_TYPE_RANDOM_NUMBER = "RESULT_TYPE_RANDOM_NUMBER"
